export const PROJECT_STATUS = {
  PENDING: 'pending',
  RUNNING: 'running',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
  FAILED: 'failed',
} as const;

export type ProjectStatus = (typeof PROJECT_STATUS)[keyof typeof PROJECT_STATUS];

export interface IProject {
  id: string;
  name: string;
  progress: number;
  status: ProjectStatus;
  owner: string;
  start_date: Date;
  end_date: Date;
  error_message: string;
  location_count: number;
}
